// 运费
export const freight = {
  freightListRules: 'n.196.997.0', // 运费详情列表-运费规则
  freightListDetail: 'n.196.998.0', // 运费详情列表-查看明细
  freightDetailRules: 'n.197.999.0' // 运费明细-运费规则
}
